"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoizedSetPasswordFormValidation = exports["default"] = void 0;

var _lruMemoize = _interopRequireDefault(require("lru-memoize"));

var _utils = require("../utils");

var _password = require("../utils/password");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var setPasswordFormValidation = (0, _utils.createValidator)({
  password: [_utils.required, _password.passwordMatched, _password.validatePassword],
  repeatPassword: [_utils.required, _password.passwordMatched]
});
var memoizedSetPasswordFormValidation = exports.memoizedSetPasswordFormValidation = (0, _lruMemoize["default"])(10)(setPasswordFormValidation);

var _default = exports["default"] = setPasswordFormValidation;